export default __webpack_public_path__ + "static/media/TX_Shen_1.a7abb138.png";